<template >
  <div>
    <h2>New Page Not Found</h2>
  </div>
</template>
<script>
export default {
  
}
</script>
<style >
  
</style>